import { useQuery } from "react-query";
import { getModules } from "../../../../actions/Utilities/CustomReport/index";

export const useGetModules = () => {
  return useQuery("GetModules", getModules, {
    refetchOnWindowFocus: false,
  });
};
